export default __webpack_public_path__ + "static/media/dullingblow2.572e49f8.png";